import { ArrowUpRight, Phone } from "lucide-react";
import { BOOKING_URL, PHONE_DISPLAY, PHONE_TEL } from "@/data";
import { track } from "@/hooks/useAnalytics";

export const BookButton = ({
  children = "Book online",
  testid,
  variant = "solid",
  className = "",
}) => {
  const base =
    "group inline-flex items-center gap-3 rounded-md font-sans font-medium transition-[background-color,color,transform,box-shadow] duration-300 hover:-translate-y-0.5 whitespace-nowrap px-7 py-3.5";
  const VARIANTS = {
    solid: "bg-forest text-cream hover:bg-pine hover:shadow-[0_12px_32px_-12px_rgba(36,54,47,0.55)]",
    light: "bg-cream text-forest hover:bg-sage",
    outline: "border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-cream",
  };
  const styles = VARIANTS[variant] || VARIANTS.solid;
  return (
    <a
      href={BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => track("book_click", { location: testid })}
      className={`${base} ${styles} ${className}`}
    >
      <span>{children}</span>
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
};

export const CallButton = ({ testid, light = true, className = "" }) => (
  <a
    href={PHONE_TEL}
    data-testid={testid}
    onClick={() => track("call_click", { location: testid })}
    className={`group inline-flex items-center gap-3 rounded-md border px-7 py-3.5 font-sans font-medium transition-[background-color,color,border-color] duration-300 hover:-translate-y-0.5 ${
      light
        ? "border-cream/25 text-cream hover:border-cream hover:bg-cream hover:text-forest"
        : "border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-cream"
    } ${className}`}
  >
    <Phone className="h-4 w-4" />
    <span>{PHONE_DISPLAY}</span>
  </a>
);
